import React from 'react';
import PropTypes from 'prop-types';

const StationIcon = ({ fill, style }) => (
  <svg
    style={{ ...style }}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M0 15V5L6.66667 0L13.3333 5V15H12.0833V5.625L6.66667 1.5625L1.25 5.625V15H0ZM3.75 13.75H9.58333V11.4583H3.75V13.75ZM3.75 10.2083H9.58333V7.91667H3.75V10.2083ZM2.5 15V6.66667H10.8333V15H2.5Z"
      fill={fill}
    />
  </svg>
);
StationIcon.propTypes = {
  fill: PropTypes.string,
  style: PropTypes.any,
};

StationIcon.defaultProps = {
  fill: '#575757',
  style: {},
};

export default StationIcon;
